<div class="ready-block" (click)="toggleTask($event)">

</div>
<div class="bar-card"
     [ngClass]="{'has-progress-bar': task.checkitemsTotal > 0 && task.checkitemsCompleted > 0}">
  <p-progressBar *ngIf="task.checkitemsTotal > 0 && task.checkitemsCompleted > 0"
                 [value]="(task.checkitemsCompleted * 100) / task.checkitemsTotal" [showValue]="false"
                 [ngClass]="{
                 'bar-low-progress': (task.checkitemsCompleted * 100) / task.checkitemsTotal <= 33,
                 'bar-middle-progress': (task.checkitemsCompleted * 100) / task.checkitemsTotal > 33 && (task.checkitemsCompleted * 100) / task.checkitemsTotal <= 66,
                 'bar-high-progress': (task.checkitemsCompleted * 100) / task.checkitemsTotal > 66 && (task.checkitemsCompleted * 100) / task.checkitemsTotal <= 100}">
  </p-progressBar>

  <div class="card-block">
    <div class="card-header">
      <div class="name-block" *ngIf="task.number && task.number >= 0 && task.clazz === 'SERVICE_ORDER_TASK'">
        SO-{{task.number}}
      </div>
      <div class="name-block" *ngIf="task.number && task.number >= 0 && task.clazz === 'WORK_ORDER_TASK'">
        WO-{{task.number}}
      </div>
      <div class="author-block">
        <div class="project-author"
             pTooltip="Created by {{task.authorName}}" tooltipPosition="bottom">
          <span *ngIf="!showFrom" style="font-weight: 100;">By: </span>
          {{task.shortAuthor}}
        </div>

        <ng-container *ngIf="showFrom">
          <div class="project-pre">
            >
          </div>

          <div class="second-author"
               pTooltip="Assigned to {{task.assignedUserName}}" tooltipPosition="bottom">
            {{task.shortAssigned}}
          </div>
        </ng-container>
      </div>

      <div class="created-date" *ngIf="task.created"
           pTooltip="Creation date" tooltipPosition="bottom">
        <span *ngIf="!isMobile" class="created-date-label">Created:</span> {{task.created | date: 'MMM d, y'}}
      </div>

      <div class="created-date updated-date" *ngIf="task.lastUpdatedDate"
           pTooltip="Updated" tooltipPosition="bottom">
        <span *ngIf="!isMobile" class="created-date-label">Updated:</span> {{task.lastUpdatedDate | date: 'MMM d, y'}}
      </div>

      <div class="project-name">
        <div (click)="openProject($event, task.projectId)" class="project-name-button"
             *ngIf="!fromProj && task.projectName" [ngClass]="{'opened-not-from-proj': !fromProj}">
          {{task.projectName}}
        </div>
      </div>

      <div class="project-date" *ngIf="task.deadline" [ngClass]="{'is-late': isLate}" pTooltip="{{isLate ? 'Overdue' : ''}}" tooltipPosition="bottom">
        Due: {{task.deadline | date: 'MMM d, y'}}
        <!-- Mar 23, 2020 -->
      </div>
    </div>

    <div class="task-delivery-text" *ngIf="task.deliveryInstructions">
      <i class="pi pi-exclamation-triangle" style="font-size: 100%"></i>

      <div class="delivery-text">{{task.deliveryInstructions}}</div>

    </div>
    <div class="task-text-block">
      <div class="task-text">{{task.text ? task.text : ''}}</div>

      <div class="task-order-icon-block {{classString}}" *ngIf="task.clazz === 'SERVICE_ORDER_TASK'">
					<span class="material-icons" pTooltip="{{statusString}}" tooltipPosition="bottom">
						{{iconString}}
					</span>
      </div>

    <div class="attachments-block"
         *ngIf="task.photoIds?.length > 0 || (!task.photoIds && task.hasFiles)"
         pTooltip="Has attachments" tooltipPosition="bottom">
        <i class="pi pi-paperclip" style="font-size: 100%"
           *ngIf="task.photoIds?.length > 3 || (!task.photoIds && task.hasFiles)"></i>

        <ng-container *ngIf="task.photoIds?.length <= 3">
            <i class="pi pi-paperclip" style="font-size: 100%" *ngFor="let photoId of task.photoIds"
               (click)="openTaskFile($event, photoId)"></i>
        </ng-container>
    </div>


      <div class="task-order-icon-block" *ngIf="task.isWorkOnSite">
        <div class="site-work-label counter">Site Work</div>
      </div>

      <div class="task-order-icon-block" *ngIf="task.checkitemsTotal > 0"
           pTooltip="Completed/Total Items" tooltipPosition="bottom">
        <div class="counter">{{task.checkitemsCompleted}}/{{task.checkitemsTotal}}</div>
      </div>

      <div class="task-chat-icon-block"
          *ngIf="task.totalComments > 0"
           pTooltip="Has{{task.unreadComments ? ' unread' : ''}} comments" tooltipPosition="bottom">
        <mat-icon class="task-chat-icon"
                  [ngClass]="{'has-comments': task.totalComments, 'has-unread-comment': task.unreadComments}">chat
        </mat-icon>
      </div>
        <div class="task-order-icon-block {{classString}}" *ngIf="task.clazz === 'SERVICE_ORDER_TASK'">
            <mat-icon *ngIf="task.isLock" class="lock-icon" pTooltip="Locked SO" tooltipPosition="bottom">lock</mat-icon>
            <!--            <mat-icon *ngIf="!task.isLock" class="lock-icon">lock_open</mat-icon>-->
        </div>
    </div>

    <div class="task-checkitems" *ngIf="task.checkItems?.length > 0"
    [ngClass]="{'collapsed-content': isCollapsed}">
      <div class="check-item-row" *ngFor="let checkItem of task.checkItems; let i = index"
           [class.checked-checkitem]="checkItem.ready">
        <div class="punch-item-block">
          <div class="check-item-index" *ngIf="task.checkItems?.length > 2">{{i + 1}}</div>
          <div class="order-icon" (click)="toggleCheckItemOrder($event, checkItem)"
               *ngIf="toggleOrders"
               [class.checked-order]="checkItem.workOrder">
            <mat-icon *ngIf="!checkItem.workOrder">check_box_outline_blank</mat-icon>
            <mat-icon *ngIf="checkItem.workOrder">check_box</mat-icon>
          </div>

          <div class="check-icon" (click)="toggleReady($event, checkItem)">
            <mat-icon>done</mat-icon>
          </div>

          <div class="punchlist-checkitem-title-tags">
            <div class="punchlist-checkitem-title">
              <span>{{checkItem.name}}</span>

              <div *ngIf="loadingSpinnerId === checkItem.id" class="loading-block-spinner">
                <mat-spinner></mat-spinner>
              </div>

              <i class="pi pi-paperclip" style="font-size: 100%" *ngIf="checkItem.files?.length > 3"></i>
              <ng-container *ngIf="checkItem.files?.length <= 3">
                <i class="pi pi-paperclip" style="font-size: 100%" *ngFor="let file of checkItem.files"
                   (click)="openCheckItemFile($event, file, checkItem)"></i>
              </ng-container>


              <div style="flex: 1;" *ngIf="checkItem.addedToSoBy"></div>

              <i class="pi pi-info-circle info-circle" *ngIf="checkItem.addedToSoBy"
                 pTooltip="Added by {{checkItem.addedToSoBy.name}} at {{checkItem.addedToSoDate | date: 'MMM d, y h:mm a'}}"
                 tooltipPosition="bottom"></i>
            </div>

            <div class="punchlist-tags" *ngIf="checkItem.tags?.length > 0">
              <div class="punchlist-tag {{tag?.type?.title}}-tag" *ngFor="let tag of checkItem.tags"
                   (click)="toggleTag($event, tag)"
                   [ngClass]="{
                   'ready-tag': tag.ready,
                   'sent-tag': tag.sentDate,
                   'missed-tag': tag.name === 'Amount' && !tag.invoiceId}">
								<span class="tag-span">
                  {{tag?.type?.title}}
                  <span *ngIf="tag.name === 'Amount'">
                    <span *ngIf="!tag.sentDate && !tag.ready"> - Not Sent</span>
                    <span *ngIf="tag.sentDate && !tag.ready"> - Not Paid</span>
                    <span *ngIf="!tag.invoiceId && !tag.ready"> - Missing</span>
                    <span *ngIf="tag.ready"> - Paid</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <div class="show-more-block" (click)="toggleCollapse($event)"
           *ngIf="task.checkItems !== undefined && task.checkItems !== null && task.checkItems.length > 1">
          <ng-container *ngIf="isCollapsed">
              <div class="hide-text">
                  Show ({{task.checkitemsCompleted}}/{{task.checkitemsTotal}})
              </div>
          </ng-container>
          <ng-container *ngIf="!isCollapsed">
              <div class="hide-text">
                  Hide ({{task.checkitemsCompleted}}/{{task.checkitemsTotal}})
              </div>
          </ng-container>
      </div>
  </div>
</div>



<p-confirmDialog appendTo="body" icon="pi pi-paperclip" styleClass="project-panel-confirm-dialog">
</p-confirmDialog>

<input class="mobile-task-photo-input" type="file" capture="camera" id="cameraInput" name="cameraInput"
       (change)="onFileSelected($event)" (click)="testClick($event)">
